(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
(() => {
	const desktopQuery = window.matchMedia('(min-width: 1200px)');
	const instances = new WeakMap();
	const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value));

	const getHeaderOffset = () => {
		const value = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height-sticky')) || 0;
		return value + 16;
	};

	const initialise = (section) => {
		if (!section || instances.has(section)) return;

		const form = section.querySelector('.product-form');
		if (!form) return;

		let lastScrollY = window.scrollY;
		let stickyTop = getHeaderOffset();
		let frame = null;

		const getBounds = () => {
			const maximum = getHeaderOffset();
			const minimum = Math.min(maximum, window.innerHeight - form.offsetHeight - 16);
			return { minimum, maximum };
		};

		const reset = () => {
			lastScrollY = window.scrollY;

			if (!desktopQuery.matches) {
				form.style.removeProperty('--lmb-product-details-sticky-top');
				return;
			}

			const { minimum, maximum } = getBounds();
			stickyTop = clamp(form.getBoundingClientRect().top, minimum, maximum);
			form.style.setProperty('--lmb-product-details-sticky-top', `${stickyTop}px`);
		};

		const update = () => {
			frame = null;

			if (!desktopQuery.matches) {
				form.style.removeProperty('--lmb-product-details-sticky-top');
				lastScrollY = window.scrollY;
				return;
			}

			const currentScrollY = window.scrollY;
			const { minimum, maximum } = getBounds();
			const availableHeight = window.innerHeight - maximum - 16;

			if (form.offsetHeight <= availableHeight) {
				stickyTop = maximum;
			} else {
				stickyTop = clamp(stickyTop - (currentScrollY - lastScrollY), minimum, maximum);
			}

			form.style.setProperty('--lmb-product-details-sticky-top', `${stickyTop}px`);
			lastScrollY = currentScrollY;
		};

		const scheduleUpdate = () => {
			if (frame !== null) return;
			frame = window.requestAnimationFrame(update);
		};

		const resizeObserver = new ResizeObserver(reset);
		resizeObserver.observe(form);
		window.addEventListener('scroll', scheduleUpdate, { passive: true });
		window.addEventListener('resize', reset, { passive: true });
		desktopQuery.addEventListener('change', reset);
		reset();

		instances.set(section, {
			destroy() {
				resizeObserver.disconnect();
				window.removeEventListener('scroll', scheduleUpdate);
				window.removeEventListener('resize', reset);
				desktopQuery.removeEventListener('change', reset);
				if (frame !== null) window.cancelAnimationFrame(frame);
				form.style.removeProperty('--lmb-product-details-sticky-top');
				instances.delete(section);
			}
		});
	};

	const initialiseAll = (root = document) => {
		root.querySelectorAll('.product--lmb-editorial').forEach(initialise);
	};

	initialiseAll();
	document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
	document.addEventListener('shopify:section:unload', (event) => {
		const section = event.target.querySelector('.product--lmb-editorial');
		if (section && instances.has(section)) instances.get(section).destroy();
	});
})();

  } catch(e) { console.error(e); }
})();
})();
